import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { TYPOGRAPHY_PRIVATE_AREA_TITLE } from 'lib/typography';
import { Order } from 'types/entity/order';
import OrderItem from './OrderItem';

export interface StatusTab {
  name: string;
  slug: string;
}

interface Props {
  orders: Order[];
  loading?: boolean;
}

const Orders = ({ orders, loading }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isLargeMobileScreen] = useMediaQuery(325);
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const [overflow, setOverflow] = useState<boolean | undefined>(undefined);

  const [leftArrowAppear, setLeftArrowAppear] = useState<boolean | undefined>(undefined);
  const [rightArrowAppear, setRightArrowAppear] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    if (overflow || !isLargeMobileScreen) {
      setRightArrowAppear(true);
    }
  }, [leftArrowAppear, rightArrowAppear, isLargeMobileScreen, overflow]);

  useLayoutEffect(() => {
    if (ref?.current && ref.current.clientWidth < ref?.current.scrollWidth) setOverflow(true);
  }, [ref]);

  return (
    <>
      {loading ? (
        <div className="px-3">
          <Skeleton className="h-[30px]" />
        </div>
      ) : (
        <>
          <Typography as="h2" className={TYPOGRAPHY_PRIVATE_AREA_TITLE}>
            {formatMessage({
              id: 'privatearea.orders',
              defaultMessage: 'Ordini',
            })}
          </Typography>
          <Typography>
            {formatMessage({
              id: 'privatearea.ordersDesc',
              defaultMessage: 'Visualizza e gestisci i tuoi ordini.',
            })}
          </Typography>

          <div className="mt-5 overflow-auto">
            {orders?.map((order?: Order) => <OrderItem key={order?.orderId} order={order} />)}
          </div>
        </>
      )}
    </>
  );
};

export default Orders;
